import React from 'react';
export const PermissionsCtx = React.createContext(['']);
//# sourceMappingURL=permissions-ctx.js.map